import React, { memo } from "react";
import classNames from "classnames";
import ReactModal from "react-modal";
import { FormattedMessage, useIntl } from "gatsby-plugin-intl";
import { useModalHelpers } from "hooks/modalHelpers";
import Button from "components/Button";
import youtubePlay from "icons/youtube-play.svg";
import VideoPreview from "./VideoPreview";
import "./vlog.scss";

const YTB_CHANNEL_URL =
  "https://www.youtube.com/channel/UC1kcUMOnBa2dkmVpDtDL1Ww";

const modalStyle = {
  overlay: {
    zIndex: 99,
    background: "rgba(0, 0, 0, 0.93)",
    transition: "background .4s ease",
  },
  content: {
    width: 1200,
    margin: "auto",
    height: 600,
    maxWidth: "90%",
    maxHeight: "80%",
    padding: 0,
    background: "#000",
    border: "3px solid rgba(255, 255, 255, 0.08)",
  },
};

const modals = {
  videoPreview: "VIDEO_PREVIEW",
};

const STATIC_VIDEOS = [
  // {
  //   title: <FormattedMessage id="vlog.videoTitles.1" />,
  //   videoId: "0h0iojkdK7I",
  //   tags: [
  //     <FormattedMessage id="vlog.tags.popular" />,
  //     <FormattedMessage id="vlog.tags.playful" />,
  //     <FormattedMessage id="vlog.tags.emotional" />,
  //   ],
  // },
  {
    title: <FormattedMessage id="vlog.videoTitles.2" />,
    videoId: "HFTiHkEz6M0",
    tags: [
      <FormattedMessage id="vlog.tags.popular" />,
      <FormattedMessage id="vlog.tags.playful" />,
      <FormattedMessage id="vlog.tags.emotional" />,
    ],
  },
  {
    title: <FormattedMessage id="vlog.videoTitles.3" />,
    videoId: "gwbha7TQoUQ",
    tags: [
      <FormattedMessage id="vlog.tags.popular" />,
      <FormattedMessage id="vlog.tags.playful" />,
      <FormattedMessage id="vlog.tags.emotional" />,
    ],
  },
  {
    title: <FormattedMessage id="vlog.videoTitles.4" />,
    videoId: "ZlkfgkV6c8g",
    tags: [
      <FormattedMessage id="vlog.tags.popular" />,
      <FormattedMessage id="vlog.tags.playful" />,
      <FormattedMessage id="vlog.tags.emotional" />,
    ],
  },
  {
    /* Leaving this in arabic for lack of translation */
    title: "فوقت الشدة، نتضامنو",
    videoId: "CRmmXcHcn2w",
    tags: [
      <FormattedMessage id="vlog.tags.popular" />,
      <FormattedMessage id="vlog.tags.playful" />,
      <FormattedMessage id="vlog.tags.emotional" />,
    ],
  },
  {
    /* Leaving this in arabic for lack of translation */
    title: "مع ناس الشعبي كاش",
    videoId: "9dN3GKdyVi0",
    tags: [
      <FormattedMessage id="vlog.tags.popular" />,
      <FormattedMessage id="vlog.tags.playful" />,
      <FormattedMessage id="vlog.tags.emotional" />,
    ],
  },
  {
    /* Leaving this in arabic for lack of translation */
    title: "مع ناس الشعبي كاش الحلقة : 2 أغبالة",
    videoId: "9Bdo8yNRxwo",
    tags: [
      <FormattedMessage id="vlog.tags.popular" />,
      <FormattedMessage id="vlog.tags.playful" />,
      <FormattedMessage id="vlog.tags.emotional" />,
    ],
  },
  {
    /* Leaving this in arabic for lack of translation */
    title: "مع ناس الشعبي كاش / الحلقة 3 / سوق السبت ولاد نمة",
    videoId: "yUdUvnPJEkc",
    tags: [
      <FormattedMessage id="vlog.tags.popular" />,
      <FormattedMessage id="vlog.tags.playful" />,
      <FormattedMessage id="vlog.tags.emotional" />,
    ],
  },
];

const Vlog = () => {
  const modalHelpers = useModalHelpers();
  const { formatMessage } = useIntl();

  const handleVideoClick = (e, videoId) => {
    e.preventDefault();

    modalHelpers.setModal(modals.videoPreview, {
      videoId,
    });
  };

  return (
    <section id="vlog" className="mb-24">
      <div className="vlog-wrapper pt-24 pb-32 lg:pb-0 text-white w-full">
        <div className="container relative h-full">
          <div className="flex items-start mb-24 lg:mb-0">
            <div className="w-full lg:w-6/12">
              <h1
                className="text-white text-5xl rtl:text-6xl"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: formatMessage({ id: "vlog.title" }),
                }}
              />
            </div>
          </div>

          <div className="vlog-previews-wrapper flex flex-wrap lg:flex-no-wrap items-end static lg:absolute left-0 w-full top-0 lg:top-32 lg:px-3">
            {STATIC_VIDEOS.map((item, index) => {
              const isLastItem = STATIC_VIDEOS.length - 1 === index;

              return (
                <VideoPreview
                  link={`https://youtube.com/watch?v=${item.videoId}`}
                  onClick={e => handleVideoClick(e, item.videoId)}
                  className={classNames(
                    " w-full mb-16 lg:mb-0 last:mb-0 shadow-light",
                    !isLastItem
                      ? "lg:ltr:mr-6 lg:rtl:ml-6 lg:w-1/5"
                      : " lg:w-2/5"
                  )}
                  image={`https://i.ytimg.com/vi/${item.videoId}/maxresdefault.jpg`}
                  title={item.title}
                  // last item is large
                  size={isLastItem ? "lg" : "normal"}
                  tags={item.tags}
                />
              );
            })}
          </div>
        </div>

        <ReactModal
          isOpen={modalHelpers.isOpen(modals.videoPreview)}
          onRequestClose={() => modalHelpers.clearModal()}
          style={modalStyle}
        >
          {modalHelpers.isOpen(modals.videoPreview) && (
            // eslint-disable-next-line jsx-a11y/iframe-has-title
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${
                modalHelpers.getProps()?.videoId
              }?autoplay=1&mute=1`}
            />
          )}
        </ReactModal>
      </div>

      <Button
        variant="default"
        className="border-white mt-12 lg:mt-56 mx-auto max-w-11/12 sm:w-64 flex"
        component="a"
        href={YTB_CHANNEL_URL}
        target="_blank"
        rel="noopener"
        startIcon={<object data={youtubePlay} width="25" aria-label="play" />}
      >
        <FormattedMessage id="vlog.discoverAll" />
      </Button>
    </section>
  );
};

export default memo(Vlog);
